import { useEffect, useRef } from "react";
import { useGameStore } from "../modules/game/stores";
import { useUserDataFlattened } from "../modules";
import utils from "../utils/utils";

/**
 * 管理收藏游戏列表状态
 */
export function useFavoriteGames() {
  const { isAuthenticated } = useUserDataFlattened();
  const {
    setFavoriteGames,
    isFavoriteListLoaded,
    setFavoriteListLoaded,
    setFavoriteGameIds,
  } = useGameStore();
  const isLoadingRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setFavoriteGameIds([]);
      setFavoriteGames([]);
      setFavoriteListLoaded(false);
      return;
    }

    // 如果已经加载过且正在加载，不重复加载
    if (isFavoriteListLoaded || isLoadingRef.current) {
      return;
    }

    isLoadingRef.current = true;

    // 加载收藏游戏列表
    const loadFavorites = async () => {
      try {
        const response = await utils.request(
          "/api/game/favor_game_list",
          {
            pageNo: 1,
            pageSize: 9999,
          },
          {
            method: "POST",
          }
        );

        const resp = response.data;
        if (resp && resp.model && resp.model.content) {
          // 保存游戏列表到 store
          const games = resp.model.content.map((game: any) => ({
            ...game,
            image: game.image || game.icon,
          }));
          setFavoriteGames(games);
          setFavoriteListLoaded(true);
        }
      } catch (error) {
        console.error("Failed to load favorite games:", error);
        // 失败时也标记为已加载，避免无限重试
        setFavoriteListLoaded(true);
      } finally {
        isLoadingRef.current = false;
      }
    };

    loadFavorites();
  }, [
    isAuthenticated,
    isFavoriteListLoaded,
    setFavoriteGames,
    setFavoriteListLoaded,
    setFavoriteGameIds,
  ]);

  return {
    isFavoriteListLoaded,
  };
}
